const getEEGStream = (bufStr) => {
  const buf = JSON.parse(bufStr)
  const eegStream = buf.streams.find(s => s.stype == "EEG")
  if (!eegStream) {
    return null
  }
  const { data, starttime, samplefreq } = eegStream
  return { data, starttime, samplefreq }
}
export default getEEGStream